import { render, staticRenderFns } from "./ReportPrice.vue?vue&type=template&id=67135da3"
import script from "./ReportPrice.vue?vue&type=script&lang=js"
export * from "./ReportPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports